angular.module('elidb').filter('primary', function() {
    return function(list) {
    	if(!list) return null;
    	var trace = angular.trace;

		var results = [];
		
		for(var i = 0, count = list.length; i < count; i++){
			var item = list[i];
			if(item.exclude === "true") continue;
			results.push(item);
		}

		var match  = /^Show only/gim;

		results.sort(function(a,b) {
			if(a.label.match(match) && !b.label.match(match)) return -1;
			if(!a.label.match(match) && b.label.match(match)) return 1;
			if(a.label > b.label) return 1;
			if(a.label < b.label) return -1;
			return 0;
		});

		return results;
    };
});